import { findSectionIndex, findTabIndex } from 'utils/section/tabSection';
import { recalcSectionItems } from 'utils/section/items';
import type { ModulesAndAgendasState } from '../index';
import { getStartPos } from 'utils/section/gridUtils';

interface ResizePayload {
  focusedSectionName: string;
  currentTab: number;
  currentSubTab: number;
  originalPosition: {
    x: string;
    y: string;
  };
  newPosition: {
    x: string;
    y: string;
  };
}

export const resizeSectionItem = (state: ModulesAndAgendasState, { payload }: { payload: ResizePayload }) => {
  const { focusedSectionName, currentTab, currentSubTab, originalPosition, newPosition } = payload;

  const currentTabIndex = findTabIndex(state.tabSections, currentTab);
  if (currentTabIndex === -1) return;

  const sectionIndex = findSectionIndex(state.tabSections[currentTabIndex].sections, focusedSectionName);
  if (sectionIndex === -1) return;

  const section = state.tabSections[currentTabIndex].sections[sectionIndex];
  const subTabIndex = findTabIndex(section.formItemTabs, currentSubTab);
  if (subTabIndex === -1) return;

  const items = section.formItemTabs[subTabIndex].items;

  const itemIndex = items.findIndex((item) => {
    if (item.isEmpty) return false;

    const iX = getStartPos(item.x);
    const iY = getStartPos(item.y);
    const sX = getStartPos(originalPosition.x);
    const sY = getStartPos(originalPosition.y);

    return iX === sX && iY === sY;
  });

  if (itemIndex !== -1) {
    const item = items[itemIndex];

    item.x = newPosition.x;
    item.y = newPosition.y;

    if (item.data) {
      item.data.x = newPosition.x;
      item.data.y = newPosition.y;
    }

    items[itemIndex] = item;

    section.items = recalcSectionItems(section.formItemTabs);
  }
};
